{
  "email": "E-mail",
  "showPassword": "Afficher le mot de passe",
  "hidePassword": "Masquer le mot de passe",
  "welcomeText": "Capturez, analysez et transformez votre entreprise en quelques jours, pas en mois.",
  "certDicisTitle": "Consultez notre profil de conformité",
  "certDicisAlt": "Entreprise certifiée ISO 9001 + 27001 (DICIS)",
  "certDsgvoAlt": "Conforme au RGPD – Hébergé en Europe",
  "certGobdAlt": "GoBD Ready",
  "dontHaveAccount": "Vous n'avez pas de compte",
  "contactCompany": "Contacter BLIKS IO",
  "loading": "Chargement...",
  "byContinueTermFull": "En continuant, vous acceptez les <terms>Conditions d'utilisation</terms> et la <privacy>Politique de confidentialité</privacy> de BLIKS IO.",
  "termOfService": "Conditions d'utilisation",
  "privacyPolicy": "Politique de confidentialité",
  "termsLanguageFallbackNotice": "La version officielle de ces conditions de licence est disponible en allemand et en anglais. La version anglaise est affichée ci-dessous.",
  "backToLogin": "Retour à la connexion",
  "emailIsRequired": "L'e-mail est requis",
  "loggingOut": "Déconnexion en cours...",
  "switchingWorkspace": "Changement d’espace de travail en cours...",
  "ssoSigningIn": "Connexion en cours...",
  "ssoSignInFailed": "Échec de la connexion",
  "selectWorkspaceDescription": "Choisissez l’espace de travail dans lequel vous souhaitez continuer",
  "selectWorkspaceCurrent": "Espace de travail actuel",
  "selectWorkspacePending": "Invitation en attente",
  "noWorkspaceForEmail": "Aucun espace de travail n’a été trouvé pour cette adresse e-mail. Vérifiez l’adresse ou contactez votre administrateur."
}
